import { Alert, AlertTitle } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorMessage = ({ error }) => {
  const { t } = useTranslation();

  if (error.response) {
    return (
      <Alert severity="error">
        <AlertTitle>{t(`error.${error.response.status}.heading`)}</AlertTitle>
        <p className="mb-0">{t(`error.${error.response.status}.description`)}</p>
        {error.response.data && error.response.data.message ?
          <p className="mt-3 mb-0"><tt>{error.response.data.message}</tt></p>
        : null}
      </Alert>
    );
  }

  if (process.env.NODE_ENV === 'development') {
    if (error.message) {
      return (
        <Alert variant="danger">
          <AlertTitle>Error</AlertTitle>
          <p className="mb-0">{error.message}</p>
          {error.stack ?
            <pre className="mt-3 mb-0">{error.stack}</pre>
          : null}
        </Alert>
      );
    }
  }

  return (
    <Alert severity="error">
      {t('error.generic')}
    </Alert>
  );
};

ErrorMessage.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    response: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.shape({
        message: PropTypes.string,
      }),
    }),
    stack: PropTypes.string,
  }).isRequired,
};

export default ErrorMessage;
